import { render, staticRenderFns } from "./ForkliftProd.vue?vue&type=template&id=4afd0a01&"
import script from "./ForkliftProd.vue?vue&type=script&lang=js&"
export * from "./ForkliftProd.vue?vue&type=script&lang=js&"
import style0 from "./ForkliftProd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports